import { FC } from 'react';

import { useTranslate } from '@/shared/hooks/use-translate';

import * as Styled from './styled';

export const BlockBuyoutInfo: FC = () => {
    const { t } = useTranslate();

    return (
        <Styled.Wrapper>
            <div className="title">{t('Товар можно взять в аренду с последующим выкупом')} ✅</div>
            <div className="text info-buyout">
                {t('Это позволяет вам приобрести товар после полной оплаты всех платежей по договору.')}
            </div>
            <div className="text info-buyout">{t('У вас также есть возможность вернуть товар в любое время')}</div>
        </Styled.Wrapper>
    );
};
